var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconButtonImprimir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,6H19V1a1,1,0,0,0-1-1H6A1,1,0,0,0,5,1V6H3A3,3,0,0,0,0,9v7a3,3,0,0,0,3,3H4L3,22.76a1,1,0,0,0,.18.86A1,1,0,0,0,4,24H20a1,1,0,0,0,.79-.38,1,1,0,0,0,.18-.86L20,19h1a3,3,0,0,0,3-3V9A3,3,0,0,0,21,6ZM7,2H17V6H7ZM5.28,22l1.5-6H17.22l1.5,6ZM22,16a1,1,0,0,1-1,1H19.53L19,14.76A1,1,0,0,0,18,14H6a1,1,0,0,0-1,.76L4.47,17H3a1,1,0,0,1-1-1V9A1,1,0,0,1,3,8H21a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,18H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,10H17a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonImprimir);
export default __webpack_public_path__ + "static/media/iconButtonImprimir.97842455.svg";
export { ForwardRef as ReactComponent };